module.exports = {"schedule":{"title":"Agenda","now_playing":"Em curso","empty":{"title":"Nenhum resultado","detail":"Não existem itens futuros para mostrar"}}}